exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pie-chart-legend {\n  background-color: #f7f8fb;\n  border: 1px solid #e4e4e4;\n  border-radius: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  max-width: 450px;\n  min-width: 200px;\n  text-align: start; }\n  .pie-chart-legend .icon-border {\n    height: 16px;\n    width: 16px;\n    display: inline-block;\n    border: 1px solid #979797;\n    background-color: #ffffff; }\n  .pie-chart-legend .icon-inner {\n    width: 10px;\n    height: 10px;\n    background-color: blue;\n    margin-left: 2px;\n    margin-top: 2px; }\n  .pie-chart-legend .label {\n    display: inline-block;\n    color: #4a4a4a;\n    font-size: 14px;\n    vertical-align: text-bottom; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Chart/RadialChart/Legend/style.scss
// module id = 1035
// module chunks = 0